import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ModelThresholdsList from './ModelThresholdsList';
import { getModelThresholds, getFlowSequenceForModel, getComponentPositionsForModel, getUserProfileWidget, getUserOrgModelCategoryType } from '../../selectors/index';
import {
  getThresholdsThunk,
  describeThresholdThunk,
  postThresholdThunk,
  setThresholdChangeThunk,
  setThresholdShowScreenStatusThunk,
  setCurrentPage,
  setPageFilter,
} from '../../actions/modelThreshold';

const mapStateToProps = state => {
  return {
    thresholds: getModelThresholds(state),
    flowSequences: getFlowSequenceForModel(state),
    userProfileWidgets: getUserProfileWidget(state),
    modelComponentPositions: getComponentPositionsForModel(state),
    userModelCategories: getUserOrgModelCategoryType(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getModelThresholds: (offset, limit, filter, modelId, modelCategoryId) =>
        getThresholdsThunk(offset, limit, filter, modelId, modelCategoryId, 'MODELTHRESHOLDS'),
      saveModelThreshold: (modelThreshold, widgetCode) => postThresholdThunk(modelThreshold, widgetCode),
      describeModelThreshold: (modelThresholdId, modelCategoryId) =>
        describeThresholdThunk(modelThresholdId, modelCategoryId, 'MODELTHRESHOLDSEDIT'),
      changeModelThreshold: selectedModel => setThresholdChangeThunk(selectedModel),
      setThresholdShowScreenStatus: status => setThresholdShowScreenStatusThunk(status),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelThresholdsList);
